@if(deviceService.isMobile()){
<h2>Este Modulo não está disponível para dispositivos móveis</h2>
} @if(!deviceService.isMobile()){
<div style="display: flex; flex-wrap: nowrap;">

    <mat-tree #tree [dataSource]="dataSource" [childrenAccessor]="childrenAccessor" style="flex: 0 0 300px;background-color: transparent; height: 100%;">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding style="background-color: transparent;">
            <button mat-button [routerLink]="[node.route]">{{node.name}}</button>

        </mat-tree-node>
        <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding matTreeNodeToggle
            style="background-color: transparent;" [cdkTreeNodeTypeaheadLabel]="node.name">
            <button mat-icon-button>
                <mat-icon>
                    {{tree.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
            </button>
            {{node.name}}
        </mat-tree-node>
    </mat-tree>

    <div style="width: 80%;"><router-outlet /></div>
</div>}